import { useState, useRef } from 'react';
import { __ } from '@wordpress/i18n';
import { InspectorControls, BlockControls, AlignmentToolbar } from '@wordpress/block-editor';
import { PanelBody, PanelRow, TextControl, SelectControl, __experimentalUnitControl as UnitControl } from '@wordpress/components';

import { Label, HelpPanel, InlineDetailMediaUpload, MediaEditControl } from '../../Components';
import { pxUnit, perUnit, emUnit, vhUnit } from '../../Components/utils/options';

import { debounce } from './utils/functions';
import { embedModes } from './utils/options';
import SettingsSaveForm from './SettingsSaveForm';

const Settings = ({ attributes, setAttributes, data, dataLoading, saveData, isLoading }) => {
	const { file, config, alignment, width, height } = attributes;
	const { embedMode = '' } = config;

	const [title, setTitle] = useState(file.title);

	const onConfigChange = (type, val) => setAttributes({ config: { ...config, [type]: val } });

	const updateTitle = useRef(debounce((existingFile, text) => {
		setAttributes({ file: { ...existingFile, title: text } });
	}, 750)).current;

	return <>
		<InspectorControls>
			<div className='pebInspectorInfo'>
				Need more block like this? Checkout the bundle ➡ <a href='https://wordpress.org/plugins/b-blocks' target='_blank' rel='noopener noreferrer'>B Blocks</a>
			</div>

			<HelpPanel slug='pdf-embed-block' docsLink='https://bblockswp.com/docs/pdf-embed-block' />


			<PanelBody className='bPlPanelBody' title={__('PDF Settings', 'pdf-embed-block')}>
				<SettingsSaveForm data={data} dataLoading={dataLoading} saveData={saveData} isLoading={isLoading} />

				<Label>{__('PDF File:', 'pdf-embed-block')}</Label>
				<InlineDetailMediaUpload value={file} types={['application/pdf']} onChange={val => {
					setTitle(val.title);
					setAttributes({ file: val })
				}} placeholder={__('Enter PDF URL', 'pdf-embed-block')} />

				<Label className='mt10'>{__('PDF File Name:', 'pdf-embed-block')}</Label>
				<TextControl value={title} onChange={val => {
					setTitle(val);
					updateTitle(file, val);
				}} />

				<PanelRow>
					<Label className=''>{__('Embed Mode:', 'pdf-embed-block')}</Label>
					<SelectControl value={embedMode} onChange={val => onConfigChange('embedMode', val)} options={embedModes} />
				</PanelRow>
			</PanelBody>


			<PanelBody className='bPlPanelBody' title={__('Layout Settings', 'pdf-embed-block')} initialOpen={false}>
				<UnitControl label={__('Width:', 'pdf-embed-block')} labelPosition='left' value={width} onChange={val => setAttributes({ width: val })} units={[pxUnit(650), perUnit(100), emUnit(40)]} isResetValueOnUnitChange={true} />

				{'IN_LINE' !== embedMode && <UnitControl className='mt10' label={__('Height:', 'pdf-embed-block')} labelPosition='left' value={height} onChange={val => setAttributes({ height: val })} units={[pxUnit(459), vhUnit(100), emUnit(28)]} isResetValueOnUnitChange={true} />}
			</PanelBody>
		</InspectorControls>


		<BlockControls>
			<MediaEditControl label={__('Edit PDF:', 'pdf-embed-block')} icon='pdf' types={['application/pdf']} value={file} onChange={val => setAttributes({ file: val })} />

			<AlignmentToolbar value={alignment} onChange={val => setAttributes({ alignment: val })} describedBy={__('PDF Embed Alignment')} alignmentControls={[
				{ title: __('PDF Embed in left', 'pdf-embed-block'), align: 'left', icon: 'align-left' },
				{ title: __('PDF Embed in center', 'pdf-embed-block'), align: 'center', icon: 'align-center' },
				{ title: __('PDF Embed in right', 'pdf-embed-block'), align: 'right', icon: 'align-right' }
			]} />
		</BlockControls>
	</>;
};
export default Settings;